import { Container, Text } from '@weareconceptstudio/core';

//* Styles
import MainContentStyle from './style';

//* Components
import Editor from '@/components/Editor';
import Tag from '@/components/Tag';
import Share from '@/components/Share';
import Button from '@/components/Button';

const MainContent = ({ title, description, date, location, address, industries, link, categories }) => {
	const [dayPart, timePart] = date?.split(' - ') ?? [];

	return (
		<MainContentStyle>
			<Container
				row
				isSection>
				<div className={'col-12'}>
					<div className='date-wrapper'>
						<Text className='black-850 p1 montserrat-400'>{dayPart}</Text>
						<div className={'dot'} />
						{location && <Text className='black-850 p1 montserrat-400'>{location}</Text>}
						<div className={'dot'} />
						{address && <Text className='black-850 p1 montserrat-400'>{address}</Text>}
						<div className={'dot'} />
						{timePart && <Text className='black-850 p1 montserrat-400'>{timePart}</Text>}
					</div>
				</div>

				<div className={'col-10 col-t-12'}>
					<Text className={'black-1000 h3 montserrat-400 title'}>{title}</Text>

					<div className={'categories-wrapper'}>
						{categories?.map((category, idx) => (
							<Tag key={idx}>{category}</Tag>
						))}

						{industries?.map((industry, idx) => (
							<Tag key={idx}>{industry}</Tag>
						))}
					</div>
				</div>
				<div className={'col-2 col-t-12'} />

				<div className={'col-10 col-t-12'}>
					{description && (
						<Editor
							data={description}
							className={'desc'}
						/>
					)}
				</div>
				<div className={'col-2 col-t-12'} />

				<div className={'col-12 shared-wrapper'}>
					<Share inline />

					{link && (
						<Button
							url={link}
							text={'reserve'}
							className={'reserve-btn'}
							external
						/>
					)}
				</div>
			</Container>
		</MainContentStyle>
	);
};

export default MainContent;
